import React, { useState, useEffect, useRef, useMemo } from "react";
import { Card, Table } from "../../../utils/CustomComponents";
import gsap, { Back } from "gsap";
import profileIcon from "../../Dashboard/Components/memo.png";
import { ReactComponent as Search } from "../../../img/Section/Search.svg";
const List_of_staffs_payment_history_obj = [
    {
        avatar: profileIcon,
        name: "John Doe",
        email: "johndoe@gmail.com",
        staff_id: "wa-0219",
        role: "General Manager",
        amount_paid: "1000",
        date: "21-04-2021",
    },
];

for (let index = 0; index < 10; index++) {
    List_of_staffs_payment_history_obj.push(List_of_staffs_payment_history_obj[0]);
}
export function DashboardPanel() {
    const panel = useRef();
    useEffect(() => {
        const tl = gsap.timeline({ paused: true });
        tl.from(panel.current.children[0].children, {
            opacity: 0,
            scale: 0.7,
            stagger: { each: 0.25 },
            duration: 1,
            ease: Back.easeOut.config(2),
        }).from(panel.current.children[1].children, { opacity: 0, stagger: { each: 0.25 } }, "-=1");

        tl.play();
    }, []);

    const [List_of_staffs_payment_history, setList_of_staffs_payment_history] = useState(
        List_of_staffs_payment_history_obj
    );

    const data = useMemo(
        () => [
            ...List_of_staffs_payment_history.map(
                ({ avatar, name, email, staff_id, role, amount_paid, date }) => {
                    return {
                        staff_details: (
                            <div className="staff_details">
                                <img src={avatar} alt="avatar" />
                                <div className="details">
                                    <h3 className="name">{name}</h3>
                                    <p className="email">{email}</p>
                                </div>
                            </div>
                        ),
                        staff_id,
                        role,
                        amounnt_paid: `$${amount_paid}`,
                        date,
                    };
                }
            ),
        ],
        [List_of_staffs_payment_history]
    );

    const columns = useMemo(
        () => [
            {
                Header: "Staff",
                accessor: "staff_details",
                minWidth: 250, // accessor is the "key" in the data
            },
            {
                Header: "Staff Id",
                accessor: "staff_id",
                minWidth: 100,
            },
            {
                Header: "Role",
                accessor: "role",
                minWidth: 100,
            },
            {
                Header: "Amount Paid",
                accessor: "amounnt_paid",
                minWidth: 100,
            },
            {
                Header: "Date",
                accessor: "date",
                minWidth: 100,
            },
        ],
        []
    );

    return (
        <div id="dashboard_panel" className="panel_content company" ref={panel}>
            <div className="cards">
                <Card className="staff_count">
                    <div className="card_title">Total Staffs</div>
                    <div className="count">
                        <span>500</span>
                    </div>
                </Card>
                <Card className="pension">
                    <div className="card_title">Total Pension Paid</div>
                    <div className="count">
                        <span>
                            <span className="dolls">$</span> 7,369.83
                        </span>
                    </div>
                </Card>
            </div>
            <div className="history">
                <div className="title">History</div>
                <div className="utils">
                    <Card className="search" shadow="0px 4px 28px -13px rgba(0, 0, 0, 0.25)">
                        <input
                            type="text"
                            name="search_bar"
                            id="search"
                            placeholder="Search history by ID"
                            onChange={({ target: { value } }) => {
                                value
                                    ? setList_of_staffs_payment_history(
                                          List_of_staffs_payment_history.filter(({ staff_id }) =>
                                              staff_id.toLowerCase().match(value.toLowerCase())
                                          )
                                      )
                                    : setList_of_staffs_payment_history(
                                          List_of_staffs_payment_history_obj
                                      );
                            }}
                        />
                        <Search />
                    </Card>
                </div>
                <div className="history_table">
                    <Table
                        columns={columns}
                        data={data}
                        no_data_text="No History"
                        padding={32}
                        anim_delay={1}
                    />
                </div>
            </div>
        </div>
    );
}
